export const getSurveysService = (fetch) => async (filters) => {
    try {
        const searchParams = new URLSearchParams({
            ...filters,
            initialDate: filters.initialDate,
            finalDate: filters.finalDate,
        }).toString();
        const response = await fetch({
            url: "/api/v1/inspeccion-vehiculos/encuestas?" + searchParams,
        })
        return response;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error fetching surveys");
    }
}